import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Styles/AboutMe.scss';

const AboutMe = () => {
  const { t } = useTranslation();

  return (
    <section className="aboutme" id="aboutme">
      <h2 className="aboutme__title">{t('aboutme.title')}</h2>
      <div className="aboutme__wrapper">
        <div className="aboutme__textWrapper">
          <p className="aboutme__text">
            {t('aboutme.text1')}{' '}
            <span className="aboutme__text-span">{t('aboutme.text2')}</span>{' '}
            {t('aboutme.text3')}{' '}
            <span className="aboutme__text-span">{t('aboutme.text4')}</span>{' '}
            {t('aboutme.text5')}{' '}
            <span className="aboutme__text-span">{t('aboutme.text6')}</span>{' '}
            {t('aboutme.text7')}
          </p>
          <p className="aboutme__text">
            {t('aboutme.text8')}{' '}
            <span className="aboutme__text-span">{t('aboutme.text9')}</span>{' '}
            {t('aboutme.text10')}
          </p>
          <p className="aboutme__text">{t('aboutme.text11')} </p>
        </div>
      </div>
      <h2 className="aboutme__title">{t('aboutme.title-skills')}</h2>
      <div className="aboutme__skills">
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-html fab fa-html5"
            title="HTML5"
          ></i>
          <span className="sr-only">HTML5</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-css fab fa-css3-alt"
            title="CSS3"
          ></i>
          <span className="sr-only">CSS3</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-sass fab fa-sass"
            title="SASS"
          ></i>
          <span className="sr-only">SASS</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-js fab fa-js"
            title="JavaScript"
          ></i>
          <span className="sr-only">JavaScript</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-react fab fa-react"
            title="React"
          ></i>
          <span className="sr-only">React</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-node fab fa-node"
            title="Node"
          ></i>
          <span className="sr-only">NodeJS</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-bootstrap fab fa-bootstrap"
            title="Bootstrap"
          ></i>
          <span className="sr-only">Bootstrap</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-figma fab fa-figma"
            title="Figma"
          ></i>
          <span className="sr-only">Figma</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-linux fab fa-linux"
            title="Linux"
          ></i>
          <span className="sr-only">Linux</span>
        </div>
        <div tabIndex="0">
          <i
            className="aboutme__skills-icon icon-git fab fa-git-alt"
            title="Git"
          ></i>
          <span className="sr-only">Git</span>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
